module.exports = "/dist/bb474f16c9f76f522d656d66aa4a220e.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-500.woff2
// module id = 157
// module chunks = 0